import {ApiResponseBody} from "@/library/api/models/api"
import {apiBase} from "@/library/constants"

export const pckGetUsers = async (token: string | undefined) => {
    if (!token)
        return Promise.reject("No token provided")

    const users: ApiResponseBody<User[]> = await fetch(`${apiBase}/api/users/all`, {
        headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }).then(res => res.json())

    return users.data ?? []
}
